import { connect } from 'react-redux'
import { AppleSignupButton } from '../../../Components/AppleSignupButton'

const mapStateToProps = (state, params) => {
  return {
      text: state.localization.dictionary.login.contApple
  }
}

const AppleButtonConnected = connect(
    mapStateToProps
)(AppleSignupButton)

export {
  AppleButtonConnected as SignupButton
}
